.StatPill {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px 18px;

    /* Attention tints override the GlassSurface panel swatch. The
       doubled class keeps these ahead of the base surface colour. */
    &.isFlag {
        background: var(--soniq-t--global--background--color--status--warning--default);
        border-color: var(--soniq-t--global--border--color--status--warning--default);
    }

    &.isAlert {
        background: var(--soniq-t--global--background--color--status--danger--default);
        border-color: var(--soniq-t--global--border--color--status--danger--default);
    }
}

.StatPill__value {
    line-height: 1;
    font-variant-numeric: tabular-nums;
}
